import axios from 'axios';

// Portal ID for mediaasset.conquerenterprise.in
const PORTAL_ID = 'Conquer_Enterprise';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 
    'Content-Type': 'application/json',
    'X-Portal-Id': PORTAL_ID
  }
});

// Response interceptor for auth errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
